








































































import {
	defineComponent,
	PropType,
	reactive,
	ref,
} from '@vue/composition-api';
import { Spacing } from '@front-app/components/constants';
import { unique } from '@front-app/util/array';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import { v } from '@front-app/components/form/validation/useValidation';
import { required } from '@front-app/components/form/validation/validators';
import { useRemoveFromArray } from '@front-app/hooks/useRemoveFromArray';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useDiscussionStore } from '@front-app/store/piniaModules/discussions';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import FormInput from '@front-app/components/form/FormInput.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormError from '@front-app/components/form/FormError.vue';
import CategoriesInput from '../inputs/CategoriesInput.vue';
import { EditDiscussionState } from './Model';

export default defineComponent({
	components: {
		TrForm,
		FormSection,
		FormInput,
		FormLabel,
		FormError,
		CtaButton,
		CategoriesInput,
	},
	props: {
		discussionId: {
			type: String,
			required: true,
		},
		currentSubject: {
			type: String,
			required: true,
		},
		currentCategories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		availableCategories: {
			type: Array as PropType<string[]>,
			required: true,
		},
		canAddNewCategories: Boolean,
		canEditSubject: Boolean,
	},
	setup(props) {
		// Subject
		const subjectText = ref(props.currentSubject);
		const validation = v({
			subject: {
				value: subjectText,
				rules: [required()],
			},
		});

		// Categories
		const selectedCategories = reactive(unique(props.currentCategories));
		const removeSelectedCategory = useRemoveFromArray(selectedCategories);
		const selectedNewCategories = reactive([]);
		const removeSelectedNewCategory = useRemoveFromArray(selectedNewCategories);
		// END Categories

		// Submission
		const {
			track: trackEdits,
			isLoading: isSubmittingEdits,
		} = useAsyncStatus();
		const editDiscussion = () => {
			validation.validate();
			if (!validation.isValid.value) {
				return;
			}
			const payload: EditDiscussionState = {
				subjectText: subjectText.value,
				categories: [...selectedCategories, ...selectedNewCategories],
			};
			trackEdits(useDiscussionStore().edit(props.discussionId, payload));
		};
		// END Submission

		return {
			// Submission
			editDiscussion,
			isSubmittingEdits,
			// Util
			ButtonPalettes,
			Spacing,
			validation,
			// Subject
			subjectText,
			// Categories
			selectedCategories,
			removeSelectedCategory,
			selectedNewCategories,
			removeSelectedNewCategory,
		};
	},
});
